// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18HBM","field":"styles_field__33Xqa","fieldCol":"styles_fieldCol__q21Cu","diffCol":"styles_diffCol__156C0","diff":"styles_diff__1imYh"};